import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'

export interface ConfirmDeleteManyUsersProps {
  visible: boolean
  hideDialog: () => void
  usersCount: number
  deleteSelectedUsers: () => void
}
const ConfirmDeleteManyUsers = (props: ConfirmDeleteManyUsersProps) => {
  const deleteUsersDialogFooter = (
    <div className='users-dialog-footer'>
      <Button
        label='Não'
        icon='pi pi-times'
        outlined
        className='users-btn-cancel'
        onClick={props.hideDialog}
      />
      <Button
        label='Sim'
        icon='pi pi-check'
        severity='danger'
        className='users-btn-confirm'
        onClick={props.deleteSelectedUsers}
      />
    </div>
  )
  return (
    <Dialog
      visible={props.visible}
      style={{ width: '450px' }}
      header='Confirmar Exclusão em Lote'
      modal
      className='users-confirm-dialog'
      footer={deleteUsersDialogFooter}
      onHide={props.hideDialog}
    >
      <div className='users-confirm-content'>
        <i className='pi pi-exclamation-triangle users-warning-icon' />
        <div className='users-confirm-text'>
          <p>Tem certeza que deseja excluir os</p>
          <strong className='users-highlight'>
            {props.usersCount} usuários selecionados
          </strong>
          ?
          <p className='users-warning-text'>Esta ação não pode ser desfeita.</p>
        </div>
      </div>
    </Dialog>
  )
}
export default ConfirmDeleteManyUsers
